export default "__VITE_ASSET__7dbb61ee__"